module.exports = __webpack_public_path__ + "static/media/goodTree.9628a886.svg";